export default __webpack_public_path__ + "fonts/8a86960acfae2afd25a1fdd89f236f49fc0655fcc56f11ddfc4b747c6a76e6e8.ttf";